/* omg-story (sections/omg-story.liquid): zajednički js za sve omg-story sekcije na stranici - izvršava se jednom.
   bez siročadi u tekstu, izvori kao <sup>, mobilni swipe sa tačkicama, reveal na skrol, brojači. */
(function(){
  if(window.__ozMotion)return;window.__ozMotion=1;
  (function(){
    /* bez siročadi: jednoslovne riječi vežu se za sljedeću, zadnje dvije riječi bloka idu zajedno */
    function fix(el){
      var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT),n,last=null;
      while(n=w.nextNode()){n.nodeValue=n.nodeValue.replace(/(^|[\s(„"])([aiuskozAIUSKOZ])\s+(?=\S)/g,'$1$2 ');if(/\S/.test(n.nodeValue))last=n;}
      if(last){var v=last.nodeValue,m=v.match(/^([\s\S]*\S)\s+(\S{1,14}\s*)$/);if(m)last.nodeValue=m[1]+' '+m[2];}
    }
    /* izvori: unicode eksponenti (¹⁷ ¹⁸) -> obične cifre u <sup>, klik otvara izvore */
    var SUP='⁰¹²³⁴⁵⁶⁷⁸⁹',RX=/[⁰¹²³⁴⁵⁶⁷⁸⁹]+(?:[\s,]+[⁰¹²³⁴⁵⁶⁷⁸⁹]+)*/g;
    function norm(s){return s.trim().split(/[\s,]+/).map(function(x){return x.replace(/./g,function(c){return SUP.indexOf(c)})}).join(', ');}
    function sups(){
      var w=document.createTreeWalker(document.querySelector('main')||document.body,NodeFilter.SHOW_TEXT),n,list=[];
      while(n=w.nextNode()){if(n.parentElement.closest('.oz')&&RX.test(n.nodeValue))list.push(n);RX.lastIndex=0;}
      list.forEach(function(n){
        var frag=document.createDocumentFragment(),v=n.nodeValue,i=0,m,inSrc=!!n.parentElement.closest('.oz-src');
        RX.lastIndex=0;
        while(m=RX.exec(v)){
          frag.appendChild(document.createTextNode(v.slice(i,m.index).replace(/\s+$/,inSrc?'':'')));
          var s=document.createElement('sup');s.className='oz-fn';
          if(inSrc){s.textContent=norm(m[0]);}else{var a=document.createElement('a');a.href='#izvori';a.textContent=norm(m[0]);a.setAttribute('aria-label','izvor '+norm(m[0]));s.appendChild(a);}
          frag.appendChild(s);i=m.index+m[0].length;
        }
        frag.appendChild(document.createTextNode(v.slice(i)));n.parentNode.replaceChild(frag,n);
      });
      document.addEventListener('click',function(e){var a=e.target.closest('a[href="#izvori"]');if(!a)return;var d=document.querySelector('#izvori details.oz-src');if(d)d.open=true;});
    }
    /* mobilni swipe sa tačkicama za 01/02/03 kolone sa naslovom */
    function swipes(){
      document.querySelectorAll('.oz-cols').forEach(function(c){
        if(!c.querySelector('.oz-col--titled,.oz-col__v,.oz-col__time')||c.classList.contains('oz-cols--swipe'))return;
        c.classList.add('oz-cols--swipe');
        var cols=[].slice.call(c.children),d=document.createElement('div');d.className='oz-swdots';d.setAttribute('aria-hidden','true');
        cols.forEach(function(x,i){var b=document.createElement('i');b.addEventListener('click',function(){c.scrollTo({left:x.offsetLeft-c.offsetLeft,behavior:'smooth'})});d.appendChild(b);});
        c.parentNode.insertBefore(d,c.nextSibling);
        function mark(){var w=c.clientWidth||1,k=Math.round(c.scrollLeft/w);[].forEach.call(d.children,function(b,i){b.classList.toggle('is-on',i===k)});}
        var to;c.addEventListener('scroll',function(){requestAnimationFrame(mark);clearTimeout(to);to=setTimeout(function(){var w=c.clientWidth+parseFloat(getComputedStyle(c).columnGap||0);var k=Math.round(c.scrollLeft/w);if(Math.abs(c.scrollLeft-k*w)>2)c.scrollTo({left:k*w,behavior:'smooth'});},140);},{passive:true});mark();
      });
    }
    function run(){swipes();sups();document.querySelectorAll('.oz :is(p,h1,h2,h3,summary,figcaption,td,.oz-toc a,.oz-list__p,.oz-col__p)').forEach(function(el){if(el.querySelector('p'))return;fix(el);});}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  })();
  if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  function count(el){
    var raw=el.getAttribute('data-oz-v')||el.textContent;el.setAttribute('data-oz-v',raw);
    var nums=raw.match(/\d+/g);if(!nums)return;var t0=null,D=1400;
    function f(ts){if(!t0)t0=ts;var k=Math.min(1,(ts-t0)/D);k=1-Math.pow(1-k,3);var i=0;
      el.textContent=raw.replace(/\d+/g,function(n){return Math.round(+nums[i++]*k)});if(k<1)requestAnimationFrame(f);}
    requestAnimationFrame(f);
  }
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;var el=e.target;el.classList.add('is-in');io.unobserve(el);
    if(el.matches('.oz-col')){var v=el.querySelector('.oz-col__v');if(v)count(v);}});},{rootMargin:'0px 0px -12% 0px',threshold:.01});
  function init(){
    var vh=window.innerHeight;
    var sel='.oz:not(.oz--l-hero):not(.oz--l-scatter):not(.oz--l-banner):not(.oz--l-define):not(.oz--l-htimeline) :is(.oz-h,.oz-lead,.oz-col,.oz-list li,.oz-icon,.oz-tablist,.oz-faq__list,.oz-split__img,.oz-ctas,.oz-more,.oz-src,.oz-def,.oz-def__st,.oz-qt)';
    document.querySelectorAll(sel).forEach(function(el){
      if(el.getBoundingClientRect().top<vh)return;
      var sib=el.parentElement?[].indexOf.call(el.parentElement.children,el):0;
      if(el.matches('.oz-col,.oz-list li,.oz-icon'))el.style.setProperty('--rvd',(Math.min(sib,5)*0.09)+'s');
      el.classList.add('oz-rv');io.observe(el);
    });
    document.querySelectorAll('.oz-panel__img,.oz-col__img,.oz-wide,.oz-ph__img').forEach(function(el){var w=el.matches('img')?el.parentElement:el;if(w.getBoundingClientRect().top<vh)return;w.classList.add('oz-rv-img');io.observe(w);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
/* traka citata: na mobitelu stoji samo dok je prst na njoj */
(function(){
  function bind(){document.querySelectorAll('.oz-mq').forEach(function(m){if(m.dataset.hold)return;m.dataset.hold=1;
    m.addEventListener('touchstart',function(){m.classList.add('is-held');},{passive:true});
    ['touchend','touchcancel'].forEach(function(e){m.addEventListener(e,function(){m.classList.remove('is-held');},{passive:true});});});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
})();
